import logo from './logo.svg';
import './App.css';
import Signin1 from './pages/Signin1'

import Signin2 from './pages/Signin2'

import Register1 from './pages/Register1'
import Reset15 from './pages/Reset15'

import Footer from './pages/footer'

import { Route, BrowserRouter, Switch } from "react-router-dom";
import SandP from './pages/SandP';

import Location from './pages/Location';
import ContactUs from './pages/ContactUs';

import Card from './pages/Card';
import Checkout from './pages/Checkout';

import Profile from './pages/Profile';
import Links from './pages/Links';

import List from './pages/List';
import Reaward from './pages/Reaward';
import CoupensDetail from './pages/CoupensDetail'

import CardNew from './pages/CardNew';
import Coupens from './pages/Coupens';
import SetNewpin from './pages/SetNewpin';
import EmailPin from './pages/EmailPin';
import SmsPin from './pages/SmsPin';
import SearchResults from './pages/SearchResults';
import Messages from './pages/Messages';

import DealOfWeek from './pages/DealOfWeek';
import WeeklyAd from './pages/WeeklyAd';
import Sidebar from './pages/Sidebar';


function App() {
    return ( <
        div className = "App" >

        <
        Switch >
        <
        Route exact path = '/'
        component = { Signin1 }
        /> <
        Route path = '/Signin2'
        component = { Signin2 }
        />   <
        Route path = '/Register1'
        component = { Register1 }
        />   <
        Route path = '/Reset15'
        component = { Reset15 }
        />      <
        Route path = '/Location'
        component = { Location }
        />      <
        Route path = '/ContactUs'
        component = { ContactUs }
        />     <
        Route path = '/Checkout'
        component = { Checkout }
        />    <
        Route path = '/CardNew'
        component = { CardNew }
        />     <
        Route path = '/SandP'
        component = { SandP }
        />       <
        Route path = '/Links'
        component = { Links }
        /> <
        Route path = '/List'
        component = { List }
        />    <
        Route path = '/Reaward'
        component = { Reaward }
        />  <
        Route path = '/CoupensDetail'
        component = { CoupensDetail }
        />   <
        Route path = '/Profile'
        component = { Profile }
        />  <
        Route path = '/Coupens'
        component = { Coupens }
        />   <
        Route path = '/SetNewpin'
        component = { SetNewpin }
        />   <
        Route path = '/EmailPin'
        component = { EmailPin }
        />   <
        Route path = '/SmsPin'
        component = { SmsPin }
        />  <
        Route path = '/SearchResults'
        component = { SearchResults }
        />  <
        Route path = '/Messages'
        component = { Messages }
        />  <
        Route path = '/DealOfWeek'
        component = { DealOfWeek }
        />  <
        Route path = '/WeeklyAd'
        component = { WeeklyAd }
        />  <
        Route path = '/Sidebar'
        component = { Sidebar }
        /> 


        <
        /
        Switch > <
        /div>
    );
}

export default App;